import { cloneDeep } from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RECORD_TYPE } from '../../../constants/datatypes';
import { treeActions } from '../../../redux/slices/treeSlice';
import { getUpdatedData as inboundUpdatedData } from './NewRecord';
import { getUpdatedData as outboundUpdatedData } from './NewRecordOutbound';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genKey } from '../../../utils/utilFunctions';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

function NewAttribute({ openModal, toggle }) {
    const {t} = useTranslation();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const currentTab = rightTree.currentTab;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const templateHeader = rightTree.tree.templateHeader;

    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const contentRef = useRef();
    const content = t('BOX_LIKE_TO_PLACE_FLD_INSIDE_CURR_COND_FLD_LIST_OR_DIRECTLY_AFTER').split(`\\n`).join("<br/>");

    const getNewAtttibute = (data, key) => {
        //If it is empty so it will make first node with 'ib-0' key
        const title = getNewAttributeName(rightTree?.tree, t);
        if (!data.length) return { key: `${key}-0`, title: title, insertingPosition: 1 };

        let latestNewAttributeNum = 0;
        let insertingPosition = 0;

        data.forEach((element, index) => {
            const attributeTitle = element?.MAPNAME;

            if (attributeTitle && attributeTitle.startsWith(`${t("UNNAMED")}`)) {
                const latestUnnamedElement = Number(attributeTitle.slice(t("UNNAMED").length));
                if (!isNaN(latestUnnamedElement) && element.ICON_DISPLAY === 'ATTRIBUTE') {
                    latestNewAttributeNum =
                        latestUnnamedElement > latestNewAttributeNum ? latestUnnamedElement : latestNewAttributeNum;
                }
            }
            // Creating inserting position
            if (element.key === selectedNode.key) insertingPosition = index + 2;
        });

        const lastestAttributeKey = data[(data?.length || 1) - 1]?.key?.split('-');
        lastestAttributeKey[lastestAttributeKey?.length - 1] = +lastestAttributeKey[lastestAttributeKey?.length - 1] + 1;
        const newAttributeKey = lastestAttributeKey.join('-');

        return {
            key: newAttributeKey,
            title: title,
            insertingPosition
        }
    }

    const handleNewAttribute = (isNested) => {
        let levels = selectedNode?.key?.split("-");
        levels = levels?.splice(1);
        const translatedData = cloneDeep(rightTree.tree[currentTab].translatedData);

        const insertAttributeInNestedTree = (translatedData, levels, isNested) => {
            const level = isNested ? 0 : 1;

            if (level === levels?.length) {
                if(!translatedData?.children) translatedData.children = [];
                const { children, key } = translatedData;
                const keyType = parentScreen === 'inbound' ? 'ib' :{header: "obh-0", body: "ob-0", trailer: "obt-0"}[currentTab]
                const newAttributeDetails = children
                    ? getNewAtttibute(children, key)
                    : getNewAtttibute(translatedData, keyType);

                const newAttribute = {
                    nodeId:genKey(newAttributeDetails.title),
                    alternateNodeId:genKey(newAttributeDetails.title),
                    ATTRIBUTE_NAME: newAttributeDetails.title,
                    // DESCRIPTION: newAttributeDetails.title,
                     // Will be taken care after knowing proper usage of this
                    // GUI_XML_SORT_ORDER: newAttributeDetails.insertingPosition,
                    ICON_DISPLAY: 'ATTRIBUTE',
                    FIELDTYPE: "ALPHA",
                    XML_ATTRIBUTE: 'TRUE',
                    key: newAttributeDetails.key,
                    title: newAttributeDetails.title,
                    ROUND: true,
                    type: 'ATTRIBUTE'
                };
                if(parentScreen === 'inbound'){
                    newAttribute.MAPNAME = newAttributeDetails.title
                    newAttribute.ELEMENT_NAME = newAttributeDetails.title
                }
                if (children) {
                    if (isNested) {
                        translatedData.children.splice(0, 0, newAttribute);
                        let newKey = selectedNode.key.split('-');
                        newKey.push('0')
                        newKey = newKey.join('-');
                        newAttribute.RECORD_TYPE = translatedData.TYPE;

                        dispatch(
                            treeActions.setRightTreeSelectedNode({
                                screen: parentScreen,
                                type: currentTab,
                                data: {}
                            })
                        );
                        setTimeout(() => {
                            dispatch(
                                treeActions.setRightTreeSelectedNode({
                                    screen: parentScreen,
                                    type: currentTab,
                                    data: {
                                        ...newAttribute,
                                        key: newKey
                                    }
                                })
                            );
                        })
                    } else {
                        translatedData.children.splice(newAttributeDetails.insertingPosition - 1, 0, newAttribute);
                        let newKey = selectedNode.key.split('-');
                        newKey[newKey.length - 1] = Number(newKey[newKey.length - 1]) + 1;
                        newKey = newKey.join('-');
                        newAttribute.RECORD_TYPE = translatedData.TYPE;
                        dispatch(
                            treeActions.setRightTreeSelectedNode({
                                screen: parentScreen,
                                type: currentTab,
                                data: {}
                            })
                        );
                        setTimeout(() => {
                            dispatch(
                                treeActions.setRightTreeSelectedNode({
                                    screen: parentScreen,
                                    type: currentTab,
                                    data: {
                                        ...newAttribute,
                                        key: newKey
                                    }
                                })
                            );
                        })
                    }
                }
                return;
            }

            const isArray = Array.isArray(translatedData);

            if (isArray) {
                const nestedData = translatedData[[levels[0]]];
                const newNestedLevels = levels?.splice(1);
                insertAttributeInNestedTree(nestedData, newNestedLevels, isNested);
            } else insertAttributeInNestedTree(translatedData.children, levels, isNested);
        }

        insertAttributeInNestedTree(translatedData, levels, isNested);
        const data = parentScreen === 'inbound' ? inboundUpdatedData : outboundUpdatedData
        const updatedData = data(translatedData, templateHeader?.FILETYPE, null, parentScreen === 'workflow', currentTab);

        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: currentTab,
                data: updatedData,
            })
        );
        toggle(null);
        setShowModal(false)
    }
    setTimeout(() => {
        if (contentRef.current?.innerHTML === "") contentRef.current.innerHTML = content
    }, 0)

    useEffect(() => {
      if (parentScreen === "outbound" && templateHeader?.FILETYPE === 'XML' && openModal) {
        if((selectedNode?.key === 'ob-0' || selectedNode?.key === 'obh-0' || selectedNode?.key === 'obt-0')) {
            handleNewAttribute(true)
        }
        else if(['ELEMENT','REPEATING_ELEMENT'].includes(selectedNode?.ICON_DISPLAY)){
            handleNewAttribute(true);
            return;
        } else if(['CONDITION_IF','CONDITION_ELSE'].includes(selectedNode?.ICON_DISPLAY)) {
            setShowModal(true)
        } else {
            handleNewAttribute(false);
            return;
        }
      } else {
        if (!RECORD_TYPE[selectedNode.ICON_DISPLAY] && openModal) {
          handleNewAttribute(false);
          return;
        } else if (RECORD_TYPE[selectedNode.ICON_DISPLAY] && openModal) {
          handleNewAttribute(true);
          return;
        }
      }
    }, [openModal]);

    return (
        <>
            <Dialog open={showModal} maxWidth="xs" fullWidth>
                <DialogTitle className="dialog-header">
                    <div className="title">
                        {t("BOX_CONFIRM")}
                    </div>
                </DialogTitle>
                <DialogContent className="dialog-content" dividers>
                    <div ref={contentRef}></div>
                </DialogContent>
                <DialogActions>
                    <Button size='small' variant="outlined" color="primary" onClick={() => handleNewAttribute(true)} >
                        {t("BTN_YES")}
                    </Button>
                    <Button size='small' variant="outlined" color="primary" onClick={() => handleNewAttribute(false)} >
                        {t("BTN_NO")}
                    </Button>
                    <Button size='small' variant="outlined" color="primary" onClick={() => {
                        toggle(null);
                        setShowModal(false);
                    }} >
                        {t("BTN_CANCEL")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default NewAttribute

export const getNewAttributeName = (tree, t) => {
    const data = cloneDeep(tree);
    const body = data.body.translatedData;
    let titleNumber = 0;

    const getTitleName = (data) => {

        data.forEach((ele, idx) => {
            if (ele?.title?.startsWith(t('UNNAMED'))) {

                let title = ele.title;
                const indexOfUnderScore = title.indexOf('_');
                title = indexOfUnderScore >= 0 ? title.slice(0, indexOfUnderScore) : title;
                const latestUnnamedRecord = + title.slice(t('UNNAMED').length);

                if (!isNaN(latestUnnamedRecord)) {
                    titleNumber = latestUnnamedRecord > titleNumber ? latestUnnamedRecord : titleNumber;
                }
            }
            if (ele?.children?.length > 0) {
                getTitleName(ele.children);
            }
        })
    }
    getTitleName(body);

    return `${t('UNNAMED')}${Number(titleNumber) + 1}`
}